import { FileState } from '__generated__/globalTypes';
import { isTerminalStage, isWaitingStage } from '../tapestry/stages';

// Only settled tapes can be archived. An allowlist (rather than a denylist of in-flight
// states) fails closed: a FileState added later defaults to NOT archivable instead of
// silently slipping through while the pipeline is still writing the row. The remaining
// states (NEW, READING_FILE_HEADERS, READY_TO_PROCESS, PROCESSING, READY_TO_PERSIST,
// PERSISTING) are all in-flight — the table renders them as Reading/Processing/Saving. See ENG-2845.
const ARCHIVABLE_STATES: ReadonlySet<FileState> = new Set([
  FileState.NEEDS_MAPPING,
  FileState.PROCESSED,
  FileState.PERSISTED,
  FileState.ERROR_HEADER,
  FileState.ERROR_PASSWORD,
  FileState.ERROR,
]);

type ArchivableTape = {
  state: FileState;
  tapestry_stage?: string | null;
};

// A Tapestry tape's File.state does not track the pipeline (NEW while extracting,
// READY_TO_PERSIST while persisting), so a tape with a stage is judged by the stage: parked
// at a human gate, or stopped. PERSISTED has written the loans; Finalize only promotes it to
// COMPLETED. The api archiveLoanTapes guard applies the same rule.
export const isArchivable = (tape: ArchivableTape): boolean => {
  const stage = tape.tapestry_stage;
  if (stage) {
    return isWaitingStage(stage) || isTerminalStage(stage) || stage === 'PERSISTED';
  }
  return ARCHIVABLE_STATES.has(tape.state);
};
